import { render, staticRenderFns } from "./WorkRequestCannotDeleteItem.vue?vue&type=template&id=48f032f6&"
import script from "./WorkRequestCannotDeleteItem.vue?vue&type=script&lang=ts&"
export * from "./WorkRequestCannotDeleteItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports